import React from 'react'

import { FileDropContext } from './FileDropContext'
import { FileDropContextValue } from './types'

export const useFileDrop = (): FileDropContextValue =>
  React.useContext(FileDropContext)
